const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1%2C%20gostaria%20de%20informa%C3%A7%C3%B5es%20t%C3%A9cnicas%20sobre%20as%20m%C3%A1quinas.";

interface CompatRow {
  material: string;
  cunha: boolean;
  extrusora: boolean;
  espessura: string;
  aplicacao: string;
}

interface CunhaRow {
  modelo: string;
  potencia: string;
  espessura: string;
  velocidade: string;
  temperatura: string;
  pead: boolean;
  pvc: boolean;
  lldpe: boolean;
  destaque?: boolean;
}

interface ExtrusoraRow {
  modelo: string;
  potencia: string;
  producao: string;
  temperatura: string;
  fio: string;
  pead: boolean;
  pvc: boolean;
  lldpe: boolean;
}

const cunhaRows: CunhaRow[] = [
  {
    modelo: 'BT950',
    potencia: '2100W / 220V',
    espessura: '0,5 – 3,0 mm',
    velocidade: '5 – 8 m/min',
    temperatura: '0 – 500°C',
    pead: true,
    pvc: true,
    lldpe: true,
    destaque: true,
  },
  {
    modelo: 'Weldy WGW300',
    potencia: '2100W / 220V',
    espessura: '0,5 – 3,0 mm',
    velocidade: '5 – 9 m/min',
    temperatura: '0 – 500°C',
    pead: true,
    pvc: true,
    lldpe: true,
  },
  {
    modelo: 'BT-GM1',
    potencia: '1800W / 220V',
    espessura: '0,5 – 2,0 mm',
    velocidade: '0,5 – 7 m/min',
    temperatura: '0 – 550°C',
    pead: true,
    pvc: true,
    lldpe: true,
  },
  {
    modelo: 'BT1600',
    potencia: '1600W / 220V',
    espessura: '0,4 – 2,0 mm',
    velocidade: '0 – 5 m/min',
    temperatura: '0 – 450°C',
    pead: true,
    pvc: true,
    lldpe: true,
  },
  {
    modelo: 'BT800',
    potencia: '800W / 220V',
    espessura: '0,5 – 1,5 mm',
    velocidade: '2 – 5 m/min',
    temperatura: '0 – 400°C',
    pead: true,
    pvc: false,
    lldpe: true,
  },
  {
    modelo: 'cx300 1400W',
    potencia: '1400W / 220V',
    espessura: '0,5 – 1,8 mm',
    velocidade: '0,5 – 6 m/min',
    temperatura: '0 – 450°C',
    pead: true,
    pvc: true,
    lldpe: true,
  },
];

const extrusoraRows: ExtrusoraRow[] = [
  {
    modelo: 'Extrusora EX3',
    potencia: '3400W',
    producao: '3,5 kg/h',
    temperatura: '700°C',
    fio: 'Ø 3,0 – 4,0 mm',
    pead: true,
    pvc: false,
    lldpe: true,
  },
  {
    modelo: 'Weldy Booster EX3 Plus',
    potencia: '3400W / 220V',
    producao: '3,5 kg/h',
    temperatura: '600°C',
    fio: 'Ø 3,0 – 4,0 mm',
    pead: true,
    pvc: false,
    lldpe: true,
  },
  {
    modelo: 'Extrusora Metabo BT610A',
    potencia: '3400W',
    producao: '3,5 kg/h',
    temperatura: '600°C',
    fio: 'Ø 3,0 – 4,0 mm',
    pead: true,
    pvc: false,
    lldpe: false,
  },
];

const compatRows: CompatRow[] = [
  {
    material: 'PEAD (Polietileno de Alta Densidade)',
    cunha: true,
    extrusora: true,
    espessura: '0,5 – 3,0 mm',
    aplicacao: 'Aterros, barragens, canais, mineração',
  },
  {
    material: 'PELBD / LLDPE (Polietileno Linear de Baixa Densidade)',
    cunha: true,
    extrusora: true,
    espessura: '0,5 – 2,0 mm',
    aplicacao: 'Piscicultura, reservatórios, lagoas',
  },
  {
    material: 'PVC (Policloreto de Vinila)',
    cunha: true,
    extrusora: false,
    espessura: '0,5 – 2,0 mm',
    aplicacao: 'Impermeabilização de telhados, piscinas',
  },
  {
    material: 'PP (Polipropileno)',
    cunha: true,
    extrusora: false,
    espessura: '0,5 – 1,5 mm',
    aplicacao: 'Biodigestores, lagoas de tratamento',
  },
];

function CheckIcon({ ok }: { ok: boolean }) {
  return ok ? (
    <span className="inline-flex w-6 h-6 items-center justify-center rounded-full bg-green-100">
      <i className="ri-check-line text-green-600 text-xs" />
    </span>
  ) : (
    <span className="inline-flex w-6 h-6 items-center justify-center rounded-full bg-gray-100">
      <i className="ri-close-line text-gray-400 text-xs" />
    </span>
  );
}

export default function TechnicalCatalogSection() {
  return (
    <section id="catalogo-tecnico" className="py-24 bg-gray-50/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="mb-14">
          <span className="text-green-500 text-xs uppercase tracking-widest mb-3 block">
            Distribuidor Oficial no Brasil
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 uppercase leading-none mb-4">
            CATÁLOGO TÉCNICO<br />
            <span className="text-green-500">DE EQUIPAMENTOS</span>
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
            Especificações técnicas completas das nossas <strong className="text-gray-700">máquinas de solda geomembrana</strong> disponíveis em estoque no Brasil,
            em conformidade com as normas <strong className="text-gray-700">ABNT NBR 16199 e NBR 15352</strong>.
            Envio para todos os estados com <strong className="text-gray-700">suporte técnico pós-venda e garantia oficial</strong>.
          </p>
        </div>

        {/* Tabela 1 — Cunha Quente */}
        <div className="mb-12">
          <h3 className="text-base font-black text-gray-900 uppercase tracking-wide mb-1 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />
            Máquinas de Cunha Quente — Especificações Comparativas
          </h3>
          <p className="text-gray-400 text-xs mb-4">
            Soldagem contínua de geomembrana com solda dupla e canal de teste de pressão. Ideal para grandes áreas planas.
          </p>
          <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-gray-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Modelo</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Potência</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Espessura Geomembrana</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Velocidade (m/min)</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Temperatura (°C)</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PEAD</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PVC</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">LLDPE</th>
                </tr>
              </thead>
              <tbody>
                {cunhaRows.map((row, i) => (
                  <tr
                    key={row.modelo}
                    className={`border-t border-gray-100 transition-colors ${
                      row.destaque
                        ? 'bg-green-50/60'
                        : i % 2 === 0
                        ? 'bg-white'
                        : 'bg-gray-50/40'
                    }`}
                  >
                    <td className="px-4 py-3 font-black text-gray-900 whitespace-nowrap">
                      {row.modelo}
                      {row.destaque && (
                        <span className="ml-2 text-[10px] bg-green-500 text-white px-1.5 py-0.5 rounded-full font-bold uppercase">
                          Top
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.potencia}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.espessura}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.velocidade}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.temperatura}</td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.pead} /></td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.pvc} /></td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.lldpe} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Tabela 2 — Extrusoras */}
        <div className="mb-12">
          <h3 className="text-base font-black text-gray-900 uppercase tracking-wide mb-1 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />
            Extrusoras Manuais — Especificações Comparativas
          </h3>
          <p className="text-gray-400 text-xs mb-4">
            Soldagem por extrusão para cantos, junções, reparos e geomembranas espessas acima de 2 mm. Alta resistência mecânica.
          </p>
          <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-gray-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Modelo</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Potência</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Produção</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Temperatura Máx. (°C)</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Diâm. Fio PEAD</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PEAD</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PVC</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">LLDPE</th>
                </tr>
              </thead>
              <tbody>
                {extrusoraRows.map((row, i) => (
                  <tr
                    key={row.modelo}
                    className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/40'}`}
                  >
                    <td className="px-4 py-3 font-black text-gray-900 whitespace-nowrap">{row.modelo}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.potencia}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.producao}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.temperatura}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.fio}</td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.pead} /></td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.pvc} /></td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.lldpe} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Tabela 3 — Compatibilidade de Materiais */}
        <div className="mb-12">
          <h3 className="text-base font-black text-gray-900 uppercase tracking-wide mb-1 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />
            Compatibilidade de Materiais por Tipo de Soldagem
          </h3>
          <p className="text-gray-400 text-xs mb-4">
            Guia de compatibilidade entre tipos de geomembrana, método de soldagem e aplicações típicas no Brasil.
          </p>
          <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-gray-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide">Material</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Cunha Quente</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Extrusão</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Espessura Típica</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide">Aplicações Comuns no Brasil</th>
                </tr>
              </thead>
              <tbody>
                {compatRows.map((row, i) => (
                  <tr
                    key={row.material}
                    className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/40'}`}
                  >
                    <td className="px-4 py-3 font-semibold text-gray-800">{row.material}</td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.cunha} /></td>
                    <td className="px-4 py-3 text-center"><CheckIcon ok={row.extrusora} /></td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{row.espessura}</td>
                    <td className="px-4 py-3 text-gray-500 text-xs">{row.aplicacao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* CTA + nota técnica */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 bg-white rounded-2xl border border-gray-200 px-6 py-6">
          <div>
            <p className="text-gray-900 font-black text-sm uppercase tracking-wide mb-1">
              Precisa de orientação técnica para escolher o equipamento certo?
            </p>
            <p className="text-gray-500 text-xs leading-relaxed max-w-lg">
              Nossa equipe técnica analisa o seu projeto — espessura da geomembrana, área de soldagem, tipo de material e condições de campo —
              e indica o modelo mais adequado. <strong className="text-gray-700">Atendemos todo o Brasil</strong> com suporte pós-venda local.
            </p>
          </div>
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-black text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide flex-shrink-0"
          >
            <i className="ri-whatsapp-line" />
            Consultar Especialista
          </a>
        </div>

      </div>
    </section>
  );
}
